/*
 * File: CustomerPage.tsx
 * Project: autobuy-back-office
 * File Created: Thursday, 31st August 2023 03:22:45
 * Author: Simon (s.gourlet@autobuy.fr)
 * -----
 * Last Modified: Monday, 11th September 2023 01:28:54
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright 2022 - 2023 SAS Olivier Dubois, SAS Olivier Dubois
 */

import { Fragment, useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";
import TitlePage from "Content/HeadingPage/TitlePage/TitlePage";
import Styles from "Content/User/UserSingle.module.css";
import { UserData, UserSimple } from "Type/user.type";
import translator from "MultiLanguage/TranslationWrapper";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import UserList from "../UserList";
import SelectCommercial from "./SelectCommercial";
import UserService from "Services/Users/UserService";
import Config from "Config/Config";

function MyCommercialPage(_: any) {
    const loadData = useLoaderData() as UserSimple[];
    const [commercialSelected, setCommercialSelected] = useState<UserSimple | undefined>(loadData[0]);
    const [users, setUsers] = useState<UserData[]>([]);

    useEffect(() => {
        const handleCommercialSelected = async () => {
            if (!commercialSelected)
                return;
            const usersResp = await UserService.getUsersByCommercialID(commercialSelected.id, false);
            setUsers(usersResp);
        }

        handleCommercialSelected();
    }, [commercialSelected]);

    return (
        <Fragment>
            <div className="p-3">
                <TitlePage title={translator.decode("users.myCommercials")} backLink={RouterPathResolver.pathHome.path} />
                <SelectCommercial valueName="value" onUpdate={() => {}} className={Styles.select} CommercialID={commercialSelected ? commercialSelected.id : undefined} setNewCommercial={setCommercialSelected} label={translator.decode("dynamic.commercial")} />
            </div>
            <div className="p-3">
                <UserList Users={users ?? []} indicators={false} nbPage={Config.COMMON.NB_PAGES} botPagination={true} actions={false} />
            </div>
        </Fragment>
    );
}

export default MyCommercialPage;
